import React from 'react';
import styled from '@emotion/styled';
import NoStylesButton from '@/components/Packaging/LayeredTimeline/common/NoStylesButton';
import { Tooltip, type TooltipProps } from '@mui/material';

interface Props {
  children: React.ReactNode;
  title: string;
  tooltipPlacement?: TooltipProps['placement'];
  className?: string;
  onClick(): void;
}

const IconButton: React.FC<Props> = ({ children, title, tooltipPlacement, className, onClick }) => (
  <Tooltip title={title} placement={tooltipPlacement}>
    <IconButtonStyled className={className} onClick={onClick}>
      {children}
    </IconButtonStyled>
  </Tooltip>
);

export default IconButton;

const IconButtonStyled = styled(NoStylesButton)`
  display: block;
  padding: ${({ theme }) => theme.spacing(0.25)};
  cursor: pointer;
`;
